import { Component, OnChanges, Input } from '@angular/core';

import { BaseShiftBlockGridComponent } from '../../base-grid/base-shiftblock-grid/base-shiftblock-grid.component';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { ShiftCell } from '../../models/shift-cell.model';
import { StaffingGridUtil } from '../../utilities/staffing-grid.util';
import { Constants } from 'src/shared/utilities/constants.util';

@Component({
    selector: 'smt-add-ons-grid',
    templateUrl: './add-ons-grid.component.html',
    styleUrls: ['./add-ons-grid.component.scss']
})
export class AddOnsGridComponent extends BaseShiftBlockGridComponent implements OnChanges {

    addOnsStaffingGrid: ShiftCell[][] = [];
    isAddOn: boolean = true;
    addOnsGridNegativeValueCounter: number;
    isAddOnsWarningPresent: boolean;
    @Input() isStaffingGridSaved: boolean;

    constructor(private _costCenterConfigurationService: CostCenterConfigurationService) {
        super(_costCenterConfigurationService);
        super.initializeGridProcess(() => this.buildAddOnsGrid(), () => super.setShiftBlocksFromSchedule());
        this.resetAddOnsNegativeValueCounter();
    }

    ngOnChanges() {
        super.Process();
        if (this.isStaffingGridSaved) {
            this.resetAddOnsNegativeValueCounter();
        }
    }

    private buildAddOnsGrid(): ShiftCell[][] {
        if (!this.shiftBlocks) {
            return;
        }

        let cells = [] as ShiftCell[];
        let columnCounter = 0;

        this.shiftBlocks.sort(s => s.startHour).forEach(s => {
            cells.push(this.buildGridCell(columnCounter.toString(), s));

            ++columnCounter;
        });

        this.addOnsStaffingGrid = this.sortRowIntoGrid(cells);

        return this.addOnsStaffingGrid;
    }

    private buildGridCell(columnId: string, shiftBlock: ShiftBlock): ShiftCell {
        let cell = new ShiftCell();

        cell.columnId = columnId;
        cell.id = "AddOns-" + shiftBlock.id;
        cell.rowId = "AddOns";
        cell.shiftBlockId = shiftBlock.id;
        cell.value = shiftBlock.addOns;

        return cell;
    }

    cellKeyPressed(currentCell: ShiftCell) {
        this.updateCell(currentCell);
    }

    onFocusOut(currentCell: ShiftCell) {
        if ((this.addOnsGridNegativeValueCounter > 0)) {
            if (this.checkForNegativeValues()) {
                this.showNegativeWarning();
            } else {
                this.clearNegativeWarning();
            }
        }

    }

    private setShiftBlocksForSave() {
        if (this.shiftBlocks) {
            this.shiftSchedule.partialShiftBlocks = this.shiftBlocks;
        }
    }

    private sortRowIntoGrid(cells: ShiftCell[]): ShiftCell[][] {
        let sortedTable: ShiftCell[][] = [];
        let sortedRow: ShiftCell[] = [];

        this.shiftBlocks.sort(s => s.startHour).forEach(s => {
            let columnCounter = 0;
            let cell = cells.find(c => c.shiftBlockId == s.id);

            if (cell) {
                sortedRow.push(cell);
            }
            else {
                sortedRow.push(this.buildGridCell(columnCounter.toString(), s));
            }

            ++columnCounter;
        });

        sortedTable.push(sortedRow);

        return sortedTable;
    }

    private updateCell(currentCell: ShiftCell) {
        let shiftBlock = this.shiftBlocks.find(b => b.id === currentCell.shiftBlockId);

        if (!shiftBlock) {
            return;
        }

        shiftBlock.addOns = currentCell.value;

        StaffingGridUtil.checkCompleteAddOnGrid(this.shiftBlocks);

        this.setShiftBlocksForSave();

        if (currentCell.value < 0) {
            this.showNegativeWarning();
            this.addOnsGridNegativeValueCounter++;
        }
        if (currentCell.value > 0 && this.addOnsGridNegativeValueCounter <= 0) {
            this._costCenterConfigurationService.clearWarning();
            this.resetAddOnsNegativeValueCounter();
        }
        this._costCenterConfigurationService.announceFormIsDirty(true);

        if (!this.checkForNegativeValues()) {
            this.clearNegativeWarning();
        }

    }

    private checkForNegativeValues() {
        return this.addOnsStaffingGrid[0].some(cell => cell.value < 0);
    }

    private clearNegativeWarning() {
        this._costCenterConfigurationService.clearWarning();
        this.resetAddOnsNegativeValueCounter();
    }

    private showNegativeWarning() {
        this._costCenterConfigurationService.announceWarning(Constants.AddOnsNegativeValueWarning);
    }
    private resetAddOnsNegativeValueCounter() {
        this.addOnsGridNegativeValueCounter = 0;
    }
}
